module.exports = __webpack_public_path__ + "img/csr2.6c94c2fb.jpeg";